export default {
    title: 'Home',
    subtitle: {
        summary: '{organization} · {tables} · {workflows}',
        tables: '{count} table | {count} tables',
        workflows: '{count} workflow | {count} workflows',
        empty: 'Set up the basics to start onboarding customers',
        'missing-tables': 'Your workflows are ready. Add a table to keep customer data next to them.',
        'missing-workflows': 'Your tables are ready. Build a workflow to start onboarding customers.',
    },
    sections: {
        'get-started': 'Get started',
        'next-steps': 'Next steps',
        data: 'Data',
        automation: 'Automation',
        analytics: 'Analytics',
        workspace: 'Workspace',
    },
    setup: {
        table: {
            title: 'Create your first table',
            description: 'Tables hold your CRM data: companies, contacts, cases. Start from scratch or import a CSV.',
            button: 'Create table',
        },
        workflow: {
            title: 'Build your first workflow',
            description: 'Automate onboarding with checks, decisions and customer-facing forms.',
        },
    },
    stats: {
        workflows: 'workflows',
        executions: 'runs, last {days} days',
        failed: '{count} failed',
    },
    cards: {
        workflows: 'Workflows',
        executions: 'Executions',
        members: {
            title: 'Members',
            description: 'Who has access to this workspace.',
        },
        insights: {
            title: 'Insights',
            description: 'Workflow insights, summary and historical charts.',
        },
        'api-docs': {
            title: 'API documentation',
            description: 'Endpoints for your custom tables.',
        },
        'workspace-settings': {
            title: 'Workspace settings',
            description: 'Name, environment and webhooks.',
        },
    },
}
